import { cn } from "@/lib/utils";

const TONES = {
  neutral: "bg-muted text-muted-foreground ring-border",
  blue: "bg-brand-light text-brand-dark ring-primary/15",
  green: "bg-success-light text-success-dark ring-success/20",
  amber: "bg-warning-light text-warning-dark ring-warning/20",
  red: "bg-error-light text-error-dark ring-error/20",
};

// Compact, removable label used for active filters and tags.
export function Chip({ label, tone = "neutral", onRemove, className, testId }) {
  return (
    <span
      data-testid={testId}
      className={cn(
        "inline-flex items-center gap-1.5 rounded-full px-2.5 py-1 text-xs font-medium ring-1",
        TONES[tone],
        className
      )}
    >
      {label}
      {onRemove && (
        <button
          type="button"
          onClick={onRemove}
          className="-mr-0.5 rounded-full p-0.5 transition-colors hover:bg-black/5"
          aria-label={`Remove ${label}`}
        >
          <svg viewBox="0 0 12 12" className="h-2.5 w-2.5" fill="none" stroke="currentColor" strokeWidth="1.6">
            <path d="M3 3l6 6M9 3l-6 6" strokeLinecap="round" />
          </svg>
        </button>
      )}
    </span>
  );
}
